import { Checkbox, HStack, Text } from '@chakra-ui/react';
import DOMPurify from 'dompurify';
import { handleAnchorClick } from 'libs/line';
import { ChangeEvent, FC } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';

type TermOfServiceProps = {
  variant: 'primary' | 'secondary';
  content: string;
  isChecked?: boolean;
  checkboxProps?: UseFormRegisterReturn;
  onCheckboxChange?: (event: ChangeEvent<HTMLInputElement>) => void;
};

/**
 * 利用規約チェックボックスコンポーネント
 */
const TermOfService: FC<TermOfServiceProps> = ({
  variant,
  content,
  isChecked,
  checkboxProps,
  onCheckboxChange
}) => (
  <HStack gap="0.375rem">
    <Checkbox
      variant={variant}
      isChecked={isChecked}
      onChange={onCheckboxChange}
      {...checkboxProps}
    />
    <Text
      fontWeight={400}
      fontSize="md"
      wordBreak="break-all"
      whiteSpace="pre-wrap"
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(content) // XSS 対策
      }}
      css={{
        a: {
          color:
            variant === 'secondary'
              ? 'var(--chakra-colors-secondary)'
              : 'var(--chakra-colors-primary)'
        }
      }}
      onClick={handleAnchorClick}
    />
  </HStack>
);

export default TermOfService;
